import { FC, useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { AuthContext } from 'src/providers/Auth/Auth';
import { Loading } from '../Loading/Loading';

export const PublicRoute: FC<RouteProps> = ({ component, ...rest }) => {
  const { isAuth, isLoading } = useContext(AuthContext);

  return !isLoading ? (
    isAuth ? (
      <Redirect to={ROUTES.home.path} />
    ) : (
      <Route {...rest} component={component} />
    )
  ) : (
    <Loading />
  );
};
